import sdk from '../../../services/client-sdk';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    clients: {},
    clientLoading: false,
    clientLoadingError: null,
    locales: []
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'clients/setState';

/*******************************************************************************
 * Reducer
 */
export default function clientsReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}


function getClients() {
    return ( dispatch ) => {

        dispatch( setState( {
            clientLoading: true,
            clientLoadingError: null
        } ) );

        sdk.getClients()
            .then( ( clients ) => {
                dispatch( setState( {
                    clients,
                    clientLoading: false
                } ) );
            } )
            .catch( ( err ) => {
                dispatch( setState( {
                    clientLoading: false,
                    clientLoadingError: err
                } ) );
            } );
    };
}
function getLocales() {
    return ( dispatch ) => {

        dispatch( setState( {
            clientLoading: true,
            clientLoadingError: null
        } ) );

        sdk.getLocales()
            .then( ( locales ) => {
                dispatch( setState( {
                    locales: locales,
                    clientLoading: false
                } ) );
            } )
            .catch( ( err ) => {
                dispatch( setState( {
                    clientLoading: false,
                    clientLoadingError: err
                } ) );
            } );
    };
}

function clearClients() {
    return ( dispatch ) => {
        initialState.clients = {};

        dispatch( setState( {
            ...initialState
        } ) );
    };
}

export const actions = {
    getClients,
    clearClients,
    getLocales
};